import React from 'react';
import { Scanner, IDetectedBarcode } from '@yudiel/react-qr-scanner';

import { PlayerContext } from '../../contexts/player';
import { OpenTask } from '../../utils/game-engine/player';
import { GameDocumentContext } from '../../contexts/game-document';
import { UpdatePlayerStateAsync } from '../../utils/game-engine/base';

type QRScannerModalProps = {
  onClose: () => void;
  onInvalid: () => void;
  onScan?: (value: string) => void;
};

export const QRScannerModal = ({
  onClose,
  onScan,
  onInvalid
}: QRScannerModalProps) => {
  const [, setPlayer] = React.useContext(PlayerContext);
  const [gameDocument] = React.useContext(GameDocumentContext);
  const hasScanned = React.useRef(false);

  const handleScan = (codes: IDetectedBarcode[]) => {
    const value = codes[0]?.rawValue;
    if (!value || hasScanned.current) return;

    hasScanned.current = true;

    const tasks = gameDocument.gameDocument?.assets.tasks ?? [];
    const taskFound = tasks.find((t) => t.id === value);

    // open the task if found and the task is QR-enabled
    if (taskFound && taskFound.enableQRCode) {
      setPlayer((prev) => {
        const response = OpenTask(prev, value);
        response.openedTask = [value, 'qr-scanned'];
        return UpdatePlayerStateAsync(prev, response);
      });
    } else {
      onInvalid();
    }

    onScan?.(value);
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      <button
        type={'button'}
        onClick={onClose}
        aria-label={'Close scanner'}
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          width: 40,
          height: 40,
          borderRadius: '50%',
          border: 'none',
          background: '#fff',
          fontSize: 20,
          cursor: 'pointer',
          zIndex: 1
        }}>
        ✕
      </button>

      <div style={{ width: '90%', maxWidth: 400 }}>
        <Scanner
          onScan={handleScan}
          onError={(error) => console.error('QR scanner error:', error)}
          formats={['qr_code']}
          constraints={{ facingMode: 'environment' }}
        />
      </div>
    </div>
  );
};
